export const setModules = (data) => {
  return {
    type: 'SET_MODULES',
    payload: data
  };
};

export const setModulesLoading = () => {
  return {
    type: 'SET_MODULES_LOADING'
  };
};

export const setModuleTemplates = (data) => {
  return {
    type: 'SET_MODULE_TEMPLATES',
    payload: data
  };
};
